<template>
	<v-breadcrumbs :items="crumbs">
		<template v-slot:divider>
			<v-icon class="mt-n3 mb-n3 mx-n1">mdi-chevron-right</v-icon>
		</template>
		<template v-slot:item="props">
			<v-breadcrumbs-item :to="props.item.to" class="mt-n3 mb-n3">
				{{ props.item.text }}
			</v-breadcrumbs-item>
		</template>
	</v-breadcrumbs>
</template>

<script>
export default {
	computed: {
		crumbs: function() {
			return this.$route.meta.breadcrumb;
		},
		title: function(){
			return this.$route.name
		}
	}
};
</script>
